import { observer } from 'mobx-react-lite';

import { useUnauthorizedDeepLinkHandlerPresenter } from './UnauthorizedDeepLinkHandler.presenter';

export const UnauthorizedDeepLinkHandler = observer(() => {
  useUnauthorizedDeepLinkHandlerPresenter();

  return null;
});
